import React from "react";
import { useLocation } from "react-router-dom";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import styles from "./styles.module.css";

const COORD_ESTADOS = {
  PE: { latitude: -8.28, longitude: -35.07 },
  SP: { latitude: -23.55, longitude: -46.63 }
};

export default function MapaResultadosPorLvPage() {
  const location = useLocation();
  const { resultados = [], candidatos = [], sigla_estado } = location.state || {};

  if (!resultados.length) {
    return <div style={{ padding: 20 }}>Nenhum dado disponível para exibir o mapa.</div>;
  }

  // Centro do mapa SEMPRE baseado no estado
  const centroEstado = COORD_ESTADOS[sigla_estado];
  const latitude = centroEstado?.latitude ?? -15.78;   // fallback: centro do Brasil
  const longitude = centroEstado?.longitude ?? -47.93; // fallback: centro do Brasil

  // Calcula o máximo de votos para normalizar o tamanho dos círculos
  const maxVotos = Math.max(
    ...resultados.flatMap((lv) =>
      lv.candidatos.map((c) => c.total_votos)
    )
  );

  return (
    <div className={styles.mapContainer}>
      <MapContainer
        center={[latitude, longitude]}
        zoom={7}
        scrollWheelZoom={true}
        className={styles.map}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Renderiza um ponto por local de votação */}
        {resultados.map((lv, idx) => {
          const vencedor = lv.candidatos.reduce((a, b) =>
            a.total_votos > b.total_votos ? a : b
          );

          const corVencedor =
            candidatos.find(
              (c) => String(c.id_candidato) === String(vencedor.id_candidato)
            )?.cor || "#007bff";

          const intensidade = vencedor.total_votos / maxVotos;

          return (
            <CircleMarker
              key={idx}
              center={[lv.latitude, lv.longitude]}
              radius={6 + intensidade * 10}
              fillColor={corVencedor}
              color={corVencedor}
              weight={1}
              opacity={0.7}
              fillOpacity={0.5 + intensidade * 0.4}
            >
              <Tooltip direction="top" offset={[0, -5]} opacity={1}>
                <div>
                  <strong>{lv.nome_local_votacao}</strong>
                  <br />
                  <em>Candidatos:</em>
                  <ul className={styles.tooltipList}>
                    {lv.candidatos
                      .sort((a, b) => b.total_votos - a.total_votos)
                      .map((cand) => {
                        const cor =
                          candidatos.find(
                            (c) => String(c.id_candidato) === String(cand.id_candidato)
                          )?.cor || "#007bff";

                        return (
                          <li key={cand.id_candidato}>
                            <span
                              className={styles.tooltipCor}
                              style={{ backgroundColor: cor }}
                            ></span>
                            {cand.nome}: {cand.total_votos} votos
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </Tooltip>
            </CircleMarker>
          );
        })}
      </MapContainer>

      <div className={styles.legenda}>
        <h4>Legenda</h4>
        <ul>
          {candidatos.map((c) => (
            <li key={c.id_candidato}>
              <span
                className={styles.legendaCor}
                style={{ backgroundColor: c.cor }}
              ></span>
              {c.nome_candidato}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
